<template>
  <span v-show="isShowPage">
    <v-row>
      <v-col v-for="(item, idx) in cardItems" :key="idx" cols="12" md="4" lg="4">
        <v-card :color="colorPicker(item.title)" class="card-dashboard2" :loading="isFetching2">
          <template slot="progress">
            <v-progress-linear
              color="primary"
              height="2"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-text>
            <span class="card-dashboard-title2">
              {{ capitalize(item.title) }}
            </span>
            <span style="float: right">
              <span class="card-dashboard-value2">
                {{ item.value }}
              </span>
              <span class="card-dashboard-unit2">nozzle</span>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <hr v-if="showDiagram" class="line-separator">
    <v-row v-show="showDiagram">
      <v-col>
        <v-card :loading="isFetching3" max-width="1080" style="white-space:nowrap !important">
          <v-img
            src="@/assets/img/diagram-bg.svg"
            :height="maxbgcard_height"
            min-width="1080"
            id="diagram"
          >
          <template slot="progress">
            <v-progress-linear
              color="primary"
              height="12"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-text>
            <v-row justify="space-around">
              <v-col cols="12" class="overflow-x-auto">
                <DiagramTop :data="diagramTop" />
                <DiagramLeft :data="diagramLeft" />
                <DiagramRight :data="diagramRight" />
                <DiagramBottom :data="diagramBottom" />
                <p
                  :style="'top: ' + diagramEntrance.positionY + 'px; left: ' + diagramEntrance.positionX + 'px; position: absolute;'"
                  class="spklu-marker-entrance"
                >
                  <v-img
                    src="../../assets/icon/ic_mapsentrance.svg"
                  ></v-img>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <hr v-if="showDiagram" class="line-separator">
    <span class="page-sub-title">{{ table_title }}</span>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          outlined
          solo
          hide-details
          v-model="search"
          class="search"
          placeholder="Search..."
          v-on:keyup.enter="getDataTable()"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <Table :headers="headers" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="5">
          <template slot="connectorStatus" slot-scope="{ item }">
            <span v-if="item.connectorStatus === 1" style="color:#5FA51D;">Available</span>
            <span v-else-if="item.connectorStatus === 2" style="color:#00A2B9;">In Use</span>
            <span v-else-if="item.connectorStatus === 3" style="color:#5FA51D;">Availble</span>
            <span v-else-if="item.connectorStatus === 0" style="color:#D0091E;">Unavailable - {{ item.statusDetail }}</span>
            <span v-else-if="item.connectorStatus === 4" style="color:#D0091E;">Unavailable - {{ item.statusDetail }}</span>
          </template>
          <template slot="statusDateSecondAgo" slot-scope="{ item }">
            {{ secondToHoursAndMinutes(item.statusDateSecondAgo) }}
          </template>
          <template slot="batPercentage" slot-scope="{ item }">
            <span v-if="item.connectorStatus === 2">
              {{ replaceIfEmpty(item.batPercentage) + '%' }}
            </span>
            <span v-else>
              N/A
            </span>
          </template>
        </Table>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import Table from '../../components/Table.vue'
import DiagramTop from '../../components/diagram/top.vue'
import DiagramLeft from '../../components/diagram/left.vue'
import DiagramRight from '../../components/diagram/right.vue'
import DiagramBottom from '../../components/diagram/bottom.vue'
import DashboardService from '@/services/DashboardService'

const dashboardService = DashboardService.build()
export default {
  name: 'Dashboard1',
  components: {
    DiagramTop,
    DiagramLeft,
    DiagramRight,
    DiagramBottom,
    Table
  },
  data: () => ({
    cardItems: [
      {
        value: 0,
        status: 1,
        title: 'available',
        order_number: 0
      },
      {
        value: 0,
        status: 2,
        title: 'in_use',
        order_number: 1
      },
      {
        value: 0,
        status: 4,
        title: 'unavailable',
        order_number: 2
      }
    ],
    headers: [
      { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'chargeBoxName', text: 'Nama Charger', align: 'center' },
      { value: 'connectorName', text: 'Konektor', align: 'center' },
      { value: 'connectorStatus', text: 'Status', align: 'center' },
      { value: 'statusDateSecondAgo', text: 'Waktu Status', align: 'center' },
      { value: 'batPercentage', text: 'Persentase', align: 'center' }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    isFetching2: false, // for cards
    isFetching3: false, // for diagram
    maxbgcard_height: 750,
    input: {
      filter_by: ''
    },
    chargeBoxList: [],
    locationMarkerList: [],

    diagramItems: [],
    diagramLeft: [],
    diagramRight: [],
    diagramTop: [],
    diagramBottom: [],
    diagramEntrance: {},
    defaultW: 1366,
    defaultH: 768,
    isShowPage: false,
    showDiagram: true,
    table_title: '',
    timer: ''
  }),
  async created () {
    // delete localStorage
    localStorage.removeItem('tableQuery')
    this.table_title = 'Detail Charger'
  },
  computed: {},
  mounted: function () {
    if (
      this.$route.path === '/dashboard/spklu-itdc-1' ||
      this.$route.path === '/dashboard/spklu-itdc-2' ||
      this.$route.path === '/dashboard/apurva-kempinski'
    ) {
      this.$nextTick(() => {
        // re-get data every 1 minute
        this.timer = setInterval(() => {
          this.resetData()
          const id = JSON.parse(localStorage.getItem('menu_status')).id
          this.getDiagramData(id)
          const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
          if (tableQuery) {
            this.getDataTable(tableQuery.page, tableQuery.size)
          } else {
            this.getDataTable()
          }

          this.showDiagram = true
          this.isShowPage = true
        }, 60000)
      })
    }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    '$route.path': {
      handler: function (path) {
        this.$nextTick(() => {
          const id = JSON.parse(localStorage.getItem('menu_status')).id
          this.getDiagramData(id)
          this.getDataTable()

          this.showDiagram = true
          this.isShowPage = true
        })
      },
      deep: true,
      immediate: true
    },
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    }
  },
  methods: {
    colorPicker (title) {
      if (title === 'available') {
        return '#9BD168'
      } else if (title === 'in_use') {
        return '#60CCDB'
      } else if (title === 'unavailable') {
        return '#F26776'
      }
    },
    overlap (rect1, rect2) {
      return (!(rect1.right < rect2.left ||
              rect1.left > rect2.right ||
              rect1.bottom < rect2.top ||
              rect1.top > rect2.bottom))
    },
    hideOverlappingTooltips () {
      var rects = []
      var tooltips = document.getElementsByClassName('leaflet-tooltip-top')
      for (var a = 0; a < tooltips.length; a++) {
        tooltips[a].style.visibility = ''
        rects[a] = tooltips[a].getBoundingClientRect()
      }
      for (var i = 0; i < tooltips.length; i++) {
        if (tooltips[i].style.visibility !== 'hidden') {
          for (var j = i + 1; j < tooltips.length; j++) {
            if (this.overlap(rects[i], rects[j])) tooltips[j].style.visibility = 'hidden'
          }
        }
      }
    },
    async resetData () {
      this.cardItems = [
        {
          value: 0,
          status: 1,
          title: 'available',
          order_number: 0
        },
        {
          value: 0,
          status: 2,
          title: 'in_use',
          order_number: 1
        },
        {
          value: 0,
          status: 4,
          title: 'unavailable',
          order_number: 2
        }
      ]
      this.items = {}
      // this.search = ''
      this.sortSettings = ''
    },
    async clearDiagram () {
      this.diagramItems = []
      this.diagramTop = []
      this.diagramRight = []
      this.diagramBottom = []
      this.diagramLeft = []
      this.diagramEntrance = {}
    },
    async getdataCard (dataCard) {
      this.cardItems = [
        {
          value: 0,
          status: 1,
          title: 'available',
          order_number: 0
        },
        {
          value: 0,
          status: 2,
          title: 'in_use',
          order_number: 1
        },
        {
          value: 0,
          status: 4,
          title: 'unavailable',
          order_number: 2
        }
      ]

      this.isFetching2 = true
      // set cards value
      dataCard.forEach(e => {
        if (e.status === 1 || e.status === 3) {
          this.cardItems[0].value = e.count
          this.cardItems[0].order_number = 0
        } else if (e.status === 2) {
          this.cardItems[1].value = e.count
          this.cardItems[1].order_number = 1
        } else if (e.status === 0 || e.status === 4) {
          this.cardItems[2].value = e.count
          this.cardItems[2].order_number = 2
        }
      })
      this.isFetching2 = false
    },
    async getDiagramData (idSpklu) {
      const param = {
        idSpklu: idSpklu
      }

      const response = await dashboardService.getCardAndDiagram(param)

      if (response.data.status === 200) {
        const dataCard = response.data.data.summaryConnectors

        await this.getdataCard(dataCard)

        this.isFetching3 = true

        if (this.showDiagram) {
          // wait to clear diagram then continue
          await this.clearDiagram()
          // set diagrams data
          this.diagramItems = response.data.data.shelters

          // get entrance coordinate
          const entranceIdx = this.diagramItems.findIndex(x => x.name === 'ENTRANCE')
          if (entranceIdx > -1) {
            this.diagramEntrance = this.diagramItems[entranceIdx]
            this.diagramItems.splice(entranceIdx, 1)

            // const deviceWidth = window.screen.availWidth
            // const deviceHeight = window.screen.availHeight
            // if (deviceWidth !== this.defaultW && deviceHeight !== this.defaultH) {
            //   const newPosititon = await this.repositionBasedOnRes(this.diagramEntrance.positionX, this.diagramEntrance.positionY, deviceWidth, deviceHeight)
            //   this.diagramEntrance.positionX = newPosititon.x
            //   this.diagramItems[i].positionY = newPosititon.y
            // }
          }

          // sort charger alphabetically
          for (let loopShelter = 0; loopShelter < this.diagramItems.length; loopShelter++) {
            this.diagramItems[loopShelter].chargers.sort(function (a, b) {
              if (a.chargeBoxName < b.chargeBoxName) { return -1 }
              if (a.chargeBoxName > b.chargeBoxName) { return 1 }
              return 0
            })
            for (let loopCharger = 0; loopCharger < this.diagramItems[loopShelter].chargers.length; loopCharger++) {
              this.diagramItems[loopShelter].chargers[loopCharger].connectors.sort(function (a, b) {
                if (a.connectorName < b.connectorName) { return -1 }
                if (a.connectorName > b.connectorName) { return 1 }
                return 0
              })
            }
          }

          let maxY = 0
          for (let i = 0; i < this.diagramItems.length; i++) {
            // reposition diagram element based on device resolution
            // const deviceWidth = window.screen.availWidth
            // const deviceHeight = window.screen.availHeight
            // if (deviceWidth !== this.defaultW && deviceHeight !== this.defaultH) {
            //   const newPosititon = await this.repositionBasedOnRes(this.diagramItems[i].positionX, this.diagramItems[i].positionY, deviceWidth, deviceHeight)
            //   this.diagramItems[i].positionX = newPosititon.x
            //   this.diagramItems[i].positionY = newPosititon.y
            // }

            // get line direction
            if (this.diagramItems[i].lineDirection === 'UP') {
              const idx = this.diagramTop.findIndex(x => x.name === this.diagramItems[i].name)
              // if alreay exist
              if (idx > -1) {
                this.diagramTop[idx].chargers = this.diagramItems[i].chargers
              } else {
                this.diagramTop.push(this.diagramItems[i])
              }
            } else if (this.diagramItems[i].lineDirection === 'BOTTOM') {
              const idx = this.diagramBottom.findIndex(x => x.name === this.diagramItems[i].name)
              // if alreay exist
              if (idx > -1) {
                this.diagramBottom[idx].chargers = this.diagramItems[i].chargers
              } else {
                this.diagramBottom.push(this.diagramItems[i])
              }
            } else if (this.diagramItems[i].lineDirection === 'LEFT') {
              const idx = this.diagramLeft.findIndex(x => x.name === this.diagramItems[i].name)
              // if alreay exist
              if (idx > -1) {
                this.diagramLeft[idx].chargers = this.diagramItems[i].chargers
              } else {
                this.diagramLeft.push(this.diagramItems[i])
              }
            } else if (this.diagramItems[i].lineDirection === 'RIGHT') {
              const idx = this.diagramRight.findIndex(x => x.name === this.diagramItems[i].name)
              // if alreay exist
              if (idx > -1) {
                this.diagramRight[idx].chargers = this.diagramItems[i].chargers
              } else {
                this.diagramRight.push(this.diagramItems[i])
              }
            }

            if (maxY < this.diagramItems[i].positionY) {
              maxY = this.diagramItems[i].positionY
            }
          }
          maxY += 230
          this.maxbgcard_height = maxY
        }
        this.isFetching3 = false
      }
    },
    repositionBasedOnRes (x, y, deviceWidth, deviceHeight) {
      if (x && y) {
        let newX = 0
        let newY = 0
        newX = x * (deviceWidth / this.defaultW)
        newY = y * (deviceHeight / this.defaultH)
        return { x: newX, y: newY }
      }
    },
    async getDataTable (page, size) {
      // this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem('tableQuery', JSON.stringify({
        page: page,
        size: size,
        sort_by: tableQuery ? tableQuery.sort_by : ''
      }))

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const id = JSON.parse(localStorage.getItem('menu_status')).id
      const param = Object.assign({
        idSpklu: id,
        q: this.search,
        sort: tableQuery ? tableQuery.sort_by : ''
      }, this.paging)

      const response = await dashboardService.getPgb(param)
      if (response.data.status === 401) {
        alert.breaksession()
      }
      if (response.data.status === 200) {
        const { data: { data: { content, totalPages, number, size, totalElements } } } = response
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements
        })
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      // this.isFetching = false
    },
    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'chargeBoxName') {
            column = 'chargeBoxName'
          } else if (options.sortBy[i] === 'connectorName') {
            column = 'connectorName'
          } else if (options.sortBy[i] === 'connectorStatus') {
            column = 'connectorStatus'
          } else if (options.sortBy[i] === 'statusDateSecondAgo') {
            column = 'statusDateSecondAgo'
          } else if (options.sortBy[i] === 'batPercentage') {
            column = 'batPercentage'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        localStorage.setItem('tableQuery', JSON.stringify({
          page: tableQuery ? tableQuery.page : 0,
          size: tableQuery ? tableQuery.size : 20,
          sort_by: this.sortSettings
        }))
        tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        this.getDataTable(tableQuery.page, tableQuery.size)
      }
    },
    exportExcel () {}
  }
}
</script>
<style scoped>
</style>
